module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api-application login-form"
  }, [_c('h1', [_vm._v("申请 API 使用权限")]), _vm._v(" "), _c('el-form', {
    staticClass: "application-form",
    attrs: {
      "label-thin": "",
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.name),
      callback: function($$v) {
        _vm.application.name = $$v
      },
      expression: "application.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "error": _vm.errors.first('cellphone')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.phone),
      callback: function($$v) {
        _vm.application.phone = $$v
      },
      expression: "application.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.application.company),
      callback: function($$v) {
        _vm.application.company = $$v
      },
      expression: "application.company"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用场景"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "如教育课件，市场营销等"
    },
    model: {
      value: (_vm.application.scenario),
      callback: function($$v) {
        _vm.application.scenario = $$v
      },
      expression: "application.scenario"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "使用数量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "预计转化数量，如一年两万次"
    },
    model: {
      value: (_vm.application.estimate_ppts),
      callback: function($$v) {
        _vm.application.estimate_ppts = $$v
      },
      expression: "application.estimate_ppts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendApplication
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d402dbb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/session/api_application.view.vue
// module id = 949
// module chunks = 3